import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import Footer from "../Footer";
import { Header } from "../../Layout/Header";
import styles from "../login.module.css";
import { useSnackbar } from "notistack";
import CookieConsent from "../../CookieConsent/CookieConsent";
import { useCookies } from "react-cookie";

const MAX_EMAIL_LENGTH = 254;

function checkIsInFrame() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

const ForgotPassword = () => {
  const [cookies] = useCookies(["rp_loggedin"]); // Access cookies

  const { enqueueSnackbar } = useSnackbar();
  const isInIframe = checkIsInFrame();
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);
  const [formData, setFormData] = React.useState({
    email: "",
  });
  const [formErrors, setFormErrors] = React.useState({
    email: "",
  });
  const { search } = useLocation();

  const query = new URLSearchParams(location.search);
  const l_userId = query.get("userId");
  const l_siteId = query.get("siteId");

  function handleChange(event) {
    setFormErrors({ email: "" });
    setFormData((old) => {
      return { ...old, [event.target.id]: event.target.value };
    });
    setErrorMessage("");
  }
  function isValidEmail(email) {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email);
  }

  function validateForm(formData) {
    try {
      setFormErrors({ email: "" });

      if (formData.email === "") {
        setFormErrors((old) => {
          return { ...old, email: "Email can not be empty." };
        });
        return false;
      }

      if (!isValidEmail(formData.email)) {
        setFormErrors((old) => {
          return { ...old, email: "Invalid email address." };
        });
        return false;
      }

      if (formData.email.length > MAX_EMAIL_LENGTH) {
        setFormErrors((old) => {
          return {
            ...old,
            email: `Email cannot exceed ${MAX_EMAIL_LENGTH} characters.`,
          };
        });
        return false;
      }

      return true;
    } catch (err) {
      return false;
    }
  }
  async function onSubmit(event) {
    event.preventDefault();
    if (!validateForm(formData)) {
      return;
    }

    try {
      setIsLoading(true);
      let data = {
        email: formData.email,
      };

      await axiosInstance.post("api/gen-reset-password-link", data);
      localStorage.setItem("rp_reset_email", formData.email);
      setIsLoading(false);
      enqueueSnackbar("Password reset link sent to your email address!", {
        variant: "info",
        className: "bg-grey-400",
      });
      navigate("/login", { state: { userId: l_userId, siteId: l_siteId } });
    } catch (err) {
      setIsLoading(false);
      const message = err.response?.data?.message || err.message || "Unable to send reset link.";
      setErrorMessage(message);
      enqueueSnackbar(message, { variant: "error" });
    }
  }

  const isFormInvalid = formErrors.email !== "" || formData.email === "";

  useEffect(() => {
    // Redirect if user is already logged in
    if (cookies.rp_loggedin) {
      navigate("/choose-template"); // Redirect to the dashboard
    }
  }, [cookies.rp_loggedin, navigate]);

  return (
    <>
      <main className={`${styles.forgotPassword}`}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Header />

        <section className={`${styles.contentContaienr} flex justify-start`}>
          <div className={`${styles.leftContent} hidden md:inline-block`}>
            <img
              src={require("../../../images/login/bg-img.svg")}
              className="hidden xl:block"
            />
            <img
              src={require("../../../images/login/bg-img.svg")}
              className="small-img xl:hidden"
            />
          </div>
          <div
            className={`${styles.content} md:flex md:flex-col ${
              isInIframe ? styles.nopadding : ""
            }`}
          >
            <div className={`${styles.formContainer}`}>
              <h1 className={`${styles.heading} mt-1 md:mt-8 lg:mt-16 mb-2`}>
                Forgot password?
              </h1>
              <h4 className={`${styles.subHeading} mt-0.5`}>
                Enter your email address and we’ll send you a link to reset your
                password.
              </h4>
              <div>
                <form className={`${styles.loginForm}`} onSubmit={onSubmit}>
                  <div className={`${styles.emailRow} flex flex-col`}>
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter email address"
                      maxLength={MAX_EMAIL_LENGTH}
                      className={`${
                        formErrors.email !== "" ? "border-red-500" : ""
                      }`}
                    />
                    {formErrors.email !== "" && (
                      <label className={`${styles.errorLabels}`}>
                        {formErrors.email}
                      </label>
                    )}
                  </div>

                  <button
                    type="submit"
                    className={`${styles.primaryBtn} ${styles.loginBtn} ${
                      isFormInvalid ? "opacity-50 cursor-not-allowed" : ""
                    } `}
                    disabled={isFormInvalid}
                  >
                    Send Link
                  </button>

                  <div style={{ textAlign: "center", marginTop: "16px" }}>
                    <Link
                      to={
                        isInIframe
                          ? {
                              pathname: "/login",
                              search: `?userId=${l_userId}&siteId=${l_siteId}`,
                            }
                          : `/login${search}`
                      }
                      className="text-sm text-[#243460] font-semibold"
                      style={{ textDecoration: "none" }}
                    >
                      Try a different login method
                    </Link>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </section>
        {!isInIframe && <Footer />}
      </main>
      {!isInIframe && <CookieConsent />}
    </>
  );
};

export default ForgotPassword;
